export default {"src":"/_next/static/media/shareWhatsappGrey.195ae711.svg","height":32,"width":32};